<template>
  <div class="cb-test-setup">
    <div class="cb-test-setup__container">
      <div
        :class="step === '3' ? 'cb-test-setup__img-container--full' : ''"
        class="cb-test-setup__img-container"
      >
        <img
          src="../assets/images/setup-test-step-1-mobile.png"
          alt="Security panel illustration"
          class="cb-test-setup__img-container__img--mobile"
          v-show="step === '1'"
        />
        <img
          src="../assets/images/setup-test-step-1-desktop.png"
          alt="Security panel illustration"
          class="cb-test-setup__img-container__img--desktop"
          v-show="step === '1'"
        />
        <img
          src="../assets/images/setup-test-step-2-mobile.png"
          alt="Security panel illustration with pointer to arm the system"
          class="cb-test-setup__img-container__img--mobile"
          v-show="step === '2'"
        />
        <img
          src="../assets/images/setup-test-step-2-desktop.png"
          alt="Security panel illustration with pointer to arm the system"
          class="cb-test-setup__img-container__img--desktop"
          v-show="step === '2'"
        />
        <img
          src="../assets/images/setup-test-step-3-mobile.png"
          alt="Hand opening a door"
          class="cb-test-setup__img-container__img--mobile"
          v-show="step === '3'"
        />
        <img
          src="../assets/images/setup-test-step-3-desktop.png"
          alt="Hand opening a door"
          class="cb-test-setup__img-container__img--desktop"
          v-show="step === '3'"
        />
      </div>
      <div class="cb-test-setup__content">
        <button
          id="open-nav"
          aria-label="Open Navigation"
          @click="handleNavButtonClick"
          class="nav-button"
        >
          <img
            alt
            src="../assets/icons/menu-icon-white.svg"
            class="nav-button--mobile"
          />
          <img
            alt
            src="../assets/icons/menu-icon-blue.svg"
            class="nav-button--desktop"
          />
        </button>
        <cb-navigation v-if="isNavigationOpen"></cb-navigation>
        <p class="cb-test-setup__content__step">Step {{ step }} of 3</p>
        <component :is="`cbSetupTestPage${step}`"></component>
      </div>
    </div>
    <cb-assistance></cb-assistance>
  </div>
</template>

<script>
/* global gtag */
import { mapMutations, mapState } from 'vuex';
import SetupTestPage1 from '../components/SetupTestPage1.vue';
import SetupTestPage2 from '../components/SetupTestPage2.vue';
import SetupTestPage3 from '../components/SetupTestPage3.vue';
import Assistance from '../components/shared/Assistance.vue';
import Navigation from '../components/NavigationModal.vue';

export default {
  methods: {
    handleNavButtonClick() {
      this.setIsNavigationModalOpen(true);
      gtag('event', 'openNavClick', {
        event_label: 'open navigation',
        event_category: 'setupTest',
        value: 1,
      });
    },
    ...mapMutations(['setIsNavigationModalOpen']),
  },
  computed: {
    ...mapState({
      isNavigationOpen: (state) => state.navigationModal.isOpen,
      step: (state) => state.manualTestStep,
      modal: (state) => state.modal,
    }),
  },
  beforeRouteLeave(to, from, next) {
    if (this.modal.isOpen && this.modal.modalContent === 'cbAuth') {
      next(false);
    } else {
      next();
    }
  },
  components: {
    cbSetupTestPage1: SetupTestPage1,
    cbSetupTestPage2: SetupTestPage2,
    cbSetupTestPage3: SetupTestPage3,
    cbAssistance: Assistance,
    cbNavigation: Navigation,
  },
};
</script>

<style lang="scss" scoped>
.cb-test-setup {
  position: relative;

  &__img-container {
    height: 211px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $azure;

    &__img--desktop {
      display: none;
    }

    &--full {
      background-color: unset;
      height: 100%;
      max-height: 350px;
      overflow: hidden;

      img {
        width: 100%;
      }
    }
  }

  &__content {
    padding: 28px 20px 40px;
    max-width: 562px;
    box-sizing: border-box;
    margin: 0 auto;

    .nav-button {
      position: absolute;
      border: 0;
      padding: 0;
      top: 20px;
      right: 20px;
      background-color: transparent;
      height: 24px;
      width: 24px;

      &--desktop {
        display: none;
      }

      img {
        height: 100%;
        width: 100%;
      }
    }

    &__step {
      margin-bottom: 12px;
    }
  }

  @include desktop {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    justify-content: center;

    &__container {
      justify-content: center;
      display: flex;
      background-color: unset;
      padding: 20px;
      box-sizing: border-box;
    }

    &__img-container {
      height: 574px;
      width: 432px;
      margin: 0;
      max-width: 432px;

      &__img--mobile {
        display: none;
      }

      &__img--desktop {
        display: block;
      }

      &--full {
        max-height: unset;
        overflow: visible;

        img {
          width: unset;
        }
      }
    }

    &__content {
      position: relative;
      display: flex;
      flex-direction: column;
      height: 574px;
      width: 682px;
      background-color: white;
      margin: 0;
      max-width: 682px;
      box-sizing: border-box;
      padding: 20px;
      border-radius: 0;

      &__step {
        margin: 28px 40px 12px;
      }

      .nav-button {
        &--mobile {
          display: none;
        }

        &--desktop {
          display: block;
        }
      }
    }

    .cb-assistance {
      position: absolute;
      bottom: 0;
      left: 50%;
      top: 50%;
      transform: translate(-50%, 347px);
      height: 42px;
    }
  }
}
</style>
